import React, { useState } from "react";
import styled from "styled-components/macro";
import { Grid, Row, Col } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import SelectSanctions from "./components/select-sanctions.component";
import CreateSanction from "./components/create-sanction.component";
import UnbanUser from "./components/unban-user.component";
import ForbiddenWords from "./components/forbidden-words.component";

export default function GuidesScreen() {
  const [mode, setMode] = useState("select"); // "select" | "create"
  return (
    <div className="main-content">
      <ModeSelector>
        <Mode active={mode === "select"} onClick={() => setMode("select")}>
          Display all sanctions
        </Mode>
        <Mode active={mode === "create"} onClick={() => setMode("create")}>
          Create a sanction
        </Mode>
        <Mode active={mode === "unban"} onClick={() => setMode("unban")}>
          Unban a user
        </Mode>
        <Mode
          active={mode === "forbiddenWords"}
          onClick={() => setMode("forbiddenWords")}
        >
          Sanction-triggering keywords
        </Mode>
      </ModeSelector>
      <Grid fluid>
        <Row>
          <Col md={12}>
            {mode === "select" ? (
              <Card title="All sanctions" content={<SelectSanctions />} />
            ) : null}
            {mode === "create" ? (
              <Card title="All sanctions" content={<CreateSanction />} />
            ) : null}
            {mode === "unban" ? (
              <Card title="All sanctions" content={<UnbanUser />} />
            ) : null}
            {mode === "forbiddenWords" ? (
              <Card
                title="Sanction-triggering keywords"
                content={<ForbiddenWords />}
              />
            ) : null}
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

const ModeSelector = styled.div`
  margin-bottom: 12px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

const Mode = styled.div`
  transition: all 200ms ease;
  cursor: pointer;
  user-select: none;
  padding: 8px 24px;
  margin-right: 8px;
  font-size: 14px;
  border-bottom: 2px solid
    ${(props) => (props.active ? "#cecece" : "transparent")};

  &:hover {
    background-color: #cecece;
  }
`;
